import type { GetTweetFeed200TweetsItemMediaItemDimensions } from './getTweetFeed200TweetsItemMediaItemDimensions';
import type { GetTweetFeed200TweetsItemMediaItemType } from './getTweetFeed200TweetsItemMediaItemType';

export type GetTweetFeed200TweetsItemMediaItem = {
  dimensions?: GetTweetFeed200TweetsItemMediaItemDimensions;
  id: string;
  mimeType?: string;
  size?: number;
  thumbnailUrl?: string;
  type: GetTweetFeed200TweetsItemMediaItemType;
  url: string;
};
